import api from '@/api'
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import datepicker from 'vuejs-datepicker'
import moment from 'moment'
export default {
  props: {
    value: {
      default: null
    },
    loading: {
      default: false
    },
    livechat: {
      default: false
    },
    type: {
      default: 'edit'
    }
  },
  components: {
    Multiselect,
    datepicker
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      agentGroup: 'getAgentGroup',
      loadingAgentGroup: 'getLoadingAgentGroup',
      agentSubGroup: 'getAgentSubgroup',
      loadingAgentSubGroup: 'getLoadingAgentSubgroup',
      agents: 'getAgent',
      loadingAgent: 'getLoadingAgent'
    }),
    filterSubGroup() {
      if (this.ticket.group) {
        return this.agentSubGroup.filter((el) => {
          return el.admingroupid == this.ticket.group.id
        })
      } else {
        return []
      }
    },
    filterAgents() {
      if (this.ticket.group) {
        var agents = this.agents.filter((el) => {
          return el.admingroupid == this.ticket.group.id
        })
        if (this.ticket.subgroup) {
          agents = agents.filter((el) => {
            return el.adminsubgroupid == this.ticket.subgroup.id
          })
        }
        return agents
      } else {
        return this.agents ? this.agents : []
      }
    }
  },
  data() {
    return {
      ticket: {
        userid: null,
        first_name: null,
        last_name: null,
        group: null,
        subgroup: null,
        subject: null,
        details: null,
        assignedTo: null,
        channel: null,
        status: 'pending',
        priority: null,
        duedate: null,
        tags: null,
        contact_firstname: null,
        contact_lastname: null,
        contact_phone: null,
        contact_email: null
      },
      statusOptions: [
        'open',
        'pending',
        'answered',
        'closed',
        'cancelled',
        'cancelled by customer'
      ],

      showManage: false,
      search: '',
      loadingTicket: false,
      items: [],
      select: null,
      groupOptions: [],
      subGroupOptions: [],
      tags: [],
      tagssearch: null,
      tagitems: [{ header: 'Select an option or create one' }],
      tagediting: null,

      priority: {
        text: 'Medium',
        value: 'medium'
      },
      priorityOptions: [
        {
          text: 'Low',
          value: 'low'
        },
        {
          text: 'Medium',
          value: 'medium'
        },
        {
          text: 'High',
          value: 'high'
        }
      ],
      appOptions: ['', 'phone', 'email', 'website', 'others'],

      duedate: {
        start: null,
        starttime: null
      },

      showDueDate: false,
      showDueTimeDialog: false
    }
  },
  async mounted() {
    // await this.$store.dispatch('loadAgentGroups')

    if (this.value) {
      this.ticket = {
        ...this.value,
        id: this.value.id,
        userid: this.value.userid,
        first_name: this.value.first_name,
        last_name: this.value.last_name,
        group: null,
        subgroup: null,
        subject: this.value.subject,
        details: this.value.details,
        assignedTo: null,
        channel: this.value.channel,
        status: this.value.status,
        priority: this.value.priority,
        duedate: this.value.duedate,
        tags: this.value.tags,
        contact_firstname: this.value.contact_firstname,
        contact_lastname: this.value.contact_lastname,
        contact_phone: this.value.contact_phone,
        contact_email: this.value.contact_email
      }

      if (this.value.duedate) {
        this.duedate.start = this.value.duedate
        this.duedate.starttime = moment(this.value.duedate).format('HH:mm')
      }

      // if (this.value.assigngroupid) {
      //   var group = this.agentGroup.find(el => {
      //     return el.id == this.value.assigngroupid
      //   })
      //   if (group) this.$set(this.ticket, 'group', group)
      // }
      if (this.value.assignSubGroupId) {
        var subgroup = this.agentSubGroup.find((el) => {
          return el.id == this.value.assignSubGroupId
        })

        if (subgroup) this.$set(this.ticket, 'subgroup', subgroup)
      }
      if (this.value.assignAdminId) {
        var agent =this.agents && this.agents.length ?  this.agents.find((el) => {
          return el.adminid == this.value.assignAdminId
        }) : undefined
        if (agent) this.$set(this.ticket, 'assignedTo', agent)
      }

      if (this.value.priority) {
        this.priority = this.priorityOptions.find((el) => {
          return el.value == this.value.priority
        })
      }

      try {
        if (this.value.tags) {
          var tags = this.value.tags.split(',')
          this.tags = tags.map((el) => {
            return { text: el }
          })
        }
      } catch (error) {}
      //   if (this.value.assignAdminId) {
      //     var agents = this.agents.find(el => {
      //       return el.adminid == this.value.assignAdminId
      //     })
      //     if (agents) this.$set(this.ticket, 'assignedTo', agents)
      //   }
    } else {
      var group = this.agentGroup.find((el) => {
        return el.groupname == 'Agent'
      })
      // console.log(this.value);
      if (group) this.$set(this.ticket, 'group', group)
    }

    this.cached_ticket = JSON.stringify(this.ticket)
  },
  watch: {
    search(val) {
      val && val !== this.select && this.querySelections(val)
    },
    tags(val, prev) {
      if (val.length === prev.length) return

      this.tags = val.map((v) => {
        if (typeof v === 'string') {
          v = {
            text: v
          }

          this.tagitems.push(v)
        }

        return v
      })
    }
  },
  methods: {
    checkObject(item) {
      return typeof item !== 'object'
    },
    onAssignInput(val) {
      if (val) {
        this.ticket.group = this.agentGroup.find((el) => el.id == val.admingroupid)
        this.ticket.subgroup = this.agentSubGroup.find((el) => el.id == val.adminsubgroupid)
      }
    },
    onSelectedDueDate: function (value) {
      var vm = this

      if (moment(this.duedate.end).isBefore(value)) {
        this.duedate.end = value
      }
      vm.duedate.start = value
      vm.showDueDate = false
    },
    async onChangeGroup(val) {
      this.ticket.subgroup = null
      this.ticket.assignedTo = null
    },

    async onChangeSubGroup(val) {
      this.ticket.assignedTo = null
    },
    async openModal() {
      this.showManage = true
      this.loadingTicket = true
      // this.ticket = {
      //   userid: null,
      //   firstname: null,
      //   lastname: null,
      //   group: null,
      //   subgroup: null,
      //   subject: null,
      //   details: null,
      //   assignedTo: null,
      //   channel: null,
      //   status: 'pending',
      //   priority: null,
      //   duedate: null,
      //   tags: null,
      //   contact_firstname: null,
      //   contact_lastname: null,
      //   contact_salary: null,
      //   contact_occupation: null,
      //   contact_phone: null,
      //   contact_email: null,
      // }
      this.items = await this.getLoadUsers()
      this.loadingTicket = false
    },
    saveTicket(data) {
      return new Promise((resolve, reject) => {
        var request = data

        api.TDCreateTicket(request, function (error, response) {
          if (error) {
            reject(error)
          }
          resolve(response)
        })
      })
    },
    editTicket(data) {
      return new Promise((resolve, reject) => {
        var request = data
        api.TDUpdateTicket(request, function (error, response) {
          if (error) {
            reject(error)
          }
          resolve(response)
        })
      })
    },
    onCancel() {
      this.showManage = false
      this.ticket = JSON.parse(this.cached_ticket)
      this.select = null
    },
    addUserManual(data) {
      return new Promise((resolve, reject) => {
        var request = data
        api.postUsersmanual(request, function (error, response) {
          if (error) {
            reject(error)
          }
          resolve(response)
        })
      })
    },
    editUserManual(data) {
      return new Promise((resolve, reject) => {
        var request = {
          data: data,
          params: {
            pageid: data.pageid,
            userid: data.userid
          }
        }
        api.putUsersmanual(request, function (error, response) {
          if (error) {
            reject(error)
          }
          resolve(response)
        })
      })
    },
    async onSave() {
      let result = await this.$validator.validateAll()
      if (!result) {
        // do stuff if not valid.
        this.goToErrorInput()
        return false
      }
      this.loadingTicket = true
      try {
        var data = {}
        if (this.type == 'add') {
          if (!this.ticket.userid) {
            var request = {
              ...this.ticket,
              pageid: this.selectedBot.pageid,
              first_name: this.ticket.contact_firstname,
              last_name: this.ticket.contact_lastname,
              gender: this.ticket.gender,
              app: this.ticket.app,
              channel: this.ticket.channel,
              email: this.ticket.email,
              phoneno: this.ticket.contact_phone,
              address: this.ticket.contact_email
            }
            // console.log(this.ticket);
            var responseUser = await this.addUserManual(request)
            if (responseUser.data && responseUser.data.length > 0) {
              this.$set(this.ticket, 'userid', responseUser.data[0].id)
            }
          }

          if (this.ticket.userid) {
            data = {
              ...this.ticket,
              pageid: this.selectedBot.pageid,
              userid: this.ticket.userid,
              subject: this.ticket.subject,

              details: this.ticket.details,
              channel: this.ticket.channel,
              status: this.ticket.status,
              assignGroupId: this.ticket.group.id,
              assignSubGroupId: this.ticket.subgroup ? this.ticket.subgroup.id : null,
              assignAdminId: this.ticket.assignedTo ? this.ticket.assignedTo.adminid : null,

              priority: this.priority.value,
              duedate: this.duedate.start
                ? moment(this.duedate.start).format('YYYY-MM-DD ') +
                  (this.duedate.starttime ? this.duedate.starttime : '00:00')
                : null,
              tags: this.tags
                .map((el) => {
                  return el.text
                })
                .join(',')
            }
            var responseTicket = await this.saveTicket(data)
            if (responseTicket.data && responseTicket.data.length > 0) {
              this.cached_ticket = JSON.stringify(this.ticket)
              this.showManage = false
              this.onClearCustomer()
              this.$emit('addTicket', responseTicket.data[0])
            }
          }
        } else {
          var request = {
            ...this.ticket,
            userid: this.ticket.userid,
            pageid: this.selectedBot.pageid,
            first_name: this.ticket.firstname,
            last_name: this.ticket.lastname,
            email: this.ticket.email,
            phoneno: this.ticket.phoneno,
            address: this.ticket.address
          }
          if (!this.livechat && false) {
            var responseUser = await this.editUserManual(request)
          }
          data = {
            pageid: this.selectedBot.pageid, // required
            ticketId: this.ticket.id, // required
            priority: this.ticket.priority,
            status: this.ticket.status,
            subject: this.ticket.subject,
            details: this.ticket.details,
            contact_firstname: this.ticket.contact_firstname,
            contact_lastname: this.ticket.contact_lastname,
            contact_email: this.ticket.contact_email,
            contact_phone: this.ticket.contact_phone,
            tags: this.tags
              .map((el) => {
                return el.text
              })
              .join(',')
          }

          var responseTicket = await this.editTicket(data)
          if (responseTicket.responsecode == 200) {
            this.cached_ticket = JSON.stringify(this.ticket)
            this.showManage = false
            this.onClearCustomer()
            this.$emit('editTicket', data)
          }
        }
      } catch (error) {
        console.error(error)
      }
      this.loadingTicket = false
    },
    onChangeSelect(val) {
      if (val) {
        this.$set(this.ticket, 'userid', val.id)
        this.$set(this.ticket, 'contact_firstname', val.first_name)
        this.$set(this.ticket, 'contact_lastname', val.last_name)
        this.$set(this.ticket, 'contact_email', val.email)
        this.$set(this.ticket, 'contact_phone', val.phoneno)
        this.$set(this.ticket, 'channel', val.channel)
      }
    },
    onClearCustomer() {
      this.type = null
      this.select = null
      this.$set(this.ticket, 'userid', null)
      this.$set(this.ticket, 'contact_firstname', null)
      this.$set(this.ticket, 'contact_lastname', null)
      this.$set(this.ticket, 'contact_email', null)
      this.$set(this.ticket, 'contact_phone', null)
      this.$set(this.ticket, 'group', null)
      this.$set(this.ticket, 'subgroup', null)
      this.$set(this.ticket, 'assignedTo', null)
      this.$set(this.ticket, 'subject', null)
      this.$set(this.ticket, 'details', null)
      this.$set(this.ticket, 'priority', null)
      this.$set(this.ticket, 'status', null)
      this.$set(this.ticket, 'channel', null)
      this.$set(this.ticket, 'duedate', null)
      this.$set(this.ticket, 'tags', null)
      this.$set(this.ticket, 'first_name', null)
      this.$set(this.ticket, 'last_name', null)
    },
    async querySelections(v) {
      this.loadingTicket = true
      var search = (v || '').toLowerCase()
      this.items = await this.getLoadUsers()
      this.loadingTicket = false
    },
    getLoadUsers: function () {
      let vm = this
      return new Promise((resolve, reject) => {
        let data = {
          pageid: vm.selectedBot.pageid,
          filter: {
            fullname: vm.search
          },
          limit: 100,
          offset: 0
        }

        api.getAllUsers(data, function (error, response) {
          if (error) {
            reject(error)
          }

          var users = response.data
          resolve(users)
        })
      })
    },
    tagsedit(index, item) {
      if (!this.tagediting) {
        this.tagediting = item
        this.index = index
      } else {
        this.tagediting = null
        this.index = -1
      }
    },
    tagsfilter(item, queryText, itemText) {
      if (item.header) return false

      const hasValue = (val) => (val != null ? val : '')

      const text = hasValue(itemText)
      const query = hasValue(queryText)

      return text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/view/template/tdtawandang/management/TicketEdit.js